<script>
import AppHalfCol from "./AppHalfCol.vue";
export default {
  name: "AppTwoCols",
  components: {
    AppHalfCol,
  },
  props: {
    content: {
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
};
</script>

<template>
  <article class="twoCols vw-component">
    <div class="vw-grid">
      <AppHalfCol
        v-for="(col, index) in content"
        :key="index + 1"
        :content="col"
        :index="index + 2"
        class="column"
      />
    </div>
  </article>
</template>
<style lang="scss" scoped>
@import "../styles/01-settings/breakpoints";
@import "../styles/01-settings/mq";
.twoCols {
  padding-top: var(--component-padding);
}
.column {
  grid-column: span 6;
  &:last-child {
    padding-top: var(--component-padding);
  }
}
img {
  margin-top: auto;
  width: 100%;
  aspect-ratio: 1/1;
  object-fit: cover;
}
@include mq($from: sm, $until: md) {
  .column {
    grid-column: span 3;
    &:last-child {
      padding-top: 0;
    }
  }
}
@include mq($from: md) {
  .column {
    grid-column: span 6;
    &:last-child {
      padding-top: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/vuejs/frontend/2023-launch/components/AppTwoCols.vue